import { useActiveMember } from 'hooks';

export default function useHasCostPermission() {
  const activeMember = useActiveMember();
  return activeMember.position?.viewMemberExpenses === true && activeMember.position?.viewProjectExpenses === true;
}
